import { render, staticRenderFns } from "./HbPageMenu.vue?vue&type=template&id=46bbc521&"
import script from "./HbPageMenu.vue?vue&type=script&lang=js&"
export * from "./HbPageMenu.vue?vue&type=script&lang=js&"
import style0 from "./HbPageMenu.vue?vue&type=style&index=0&id=46bbc521&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports